import {FlowType} from "@/enum/FlowType";

export interface BankPayFlowConfig {
  flowKey: FlowType
  method: string
  payButtonsLabelKey?: string
}

export const BANK_PAY_FLOWS: BankPayFlowConfig[] = [
  {flowKey: FlowType.SBERPAY, method: 'sberbank'},
  {flowKey: FlowType.TPAY, method: 'tinkoff'},
  {flowKey: FlowType.ALFAPAY, method: 'alfabank'},
  {flowKey: FlowType.VTBPAY, method: 'vtb'},
  {flowKey: FlowType.GPBPAY, method: 'gazprombank'},
  {flowKey: FlowType.PSBPAY, method: 'promsvyaz'},
  {flowKey: FlowType.OZONPAY, method: 'ozon'},
  {flowKey: FlowType.WBPAY, method: 'wbbank'},
  {flowKey: FlowType.SOVKOMPAY, method: 'sovkom', payButtonsLabelKey: 'methods.sovkom_halva'},
]

const flowByMethod = new Map(BANK_PAY_FLOWS.map((item) => [item.method, item]))
const flowKeySet = new Set(BANK_PAY_FLOWS.map((item) => item.flowKey))

export const isBankPayFlow = (flow: string | null | undefined): flow is FlowType => {
  return flow != null && flowKeySet.has(flow as FlowType)
}

export const bankPayFlowByMethod = (method: string): BankPayFlowConfig | undefined => {
  return flowByMethod.get(method)
}

export const bankPayFlowsIn = (flowData: Record<string, unknown> | null | undefined): BankPayFlowConfig[] => {
  if (flowData == null || typeof flowData !== 'object') {
    return []
  }
  return BANK_PAY_FLOWS.filter((item) => {
    const block = flowData[item.flowKey]
    return block != null && typeof block === 'object' && !Array.isArray(block)
  })
}

export const deeplinksForPayMethod = (
  flowData: Record<string, unknown> | null | undefined,
  method: string,
): string[] | null => {
  if (flowData == null) {
    return null
  }
  const config = flowByMethod.get(method)
  if (config == null) {
    return null
  }

  const nested = flowData[config.flowKey]
  if (nested != null && typeof nested === 'object' && !Array.isArray(nested)) {
    const links = (nested as {deeplinks?: unknown}).deeplinks
    if (Array.isArray(links) && links.length > 0) {
      return links as string[]
    }
    return null
  }

  if (Array.isArray(flowData.deeplinks) && flowData.deeplinks.length > 0) {
    return flowData.deeplinks as string[]
  }
  return null
}
